export default defineNuxtPlugin(async (nuxtApp) => {
    const { GoogleMap, Marker, CustomMarker, InfoWindow } = await import("vue3-google-map");

    nuxtApp.vueApp.component('GoogleMap', GoogleMap);
    nuxtApp.vueApp.component('Marker', Marker);
    nuxtApp.vueApp.component('CustomMarker', CustomMarker);
    nuxtApp.vueApp.component('InfoWindow', InfoWindow);

    return {
        provide: {
            GoogleMap,
            CustomMarker,
            Marker,
            InfoWindow
        },
    }
})
